/**
 * Participant (Teilnehmer & Seminar-Participant Lists) API Endpoints
 * Centralizes all participant-related API calls. `id` = documentId.
 */
import type { AxiosResponse } from "axios";
import api from "../api";
import type { ApiListResponse, ApiResponse, EntityPayload, QueryParams } from "../../types/api";
import type { Teilnehm } from "../../types/entities";

export const participantApi = {
  getAll: (params: QueryParams = {}): Promise<ApiListResponse<Teilnehm>> =>
    api.get("/api/teilnehms", { params }),

  getById: (id: string, params: QueryParams = {}): Promise<ApiResponse<Teilnehm>> =>
    api.get(`/api/teilnehms/${id}`, { params }),

  create: (data: EntityPayload): Promise<ApiResponse<Teilnehm>> =>
    api.post("/api/teilnehms", { data }),

  update: (id: string, data: EntityPayload): Promise<ApiResponse<Teilnehm>> =>
    api.put(`/api/teilnehms/${id}`, { data }),

  delete: (id: string): Promise<AxiosResponse> => api.delete(`/api/teilnehms/${id}`),

  /**
   * Get all participants for a specific customer, optionally excluding those
   * already registered in a seminar.
   * @param customerId - Customer documentId
   * @param seminarId  - Optional seminar id to filter out registered participants
   */
  getByCustomer: (
    customerId: string,
    seminarId: string | number | null = null
  ): Promise<AxiosResponse> => {
    const params = seminarId ? { seminarId } : {};
    return api.get(`/api/aemters/${customerId}/participants`, { params });
  },
};

export const seminarParticipantApi = {
  getAll: (params: QueryParams = {}): Promise<AxiosResponse> =>
    api.get("/api/sem-tn-listes", { params }),

  getById: (id: string, params: QueryParams = {}): Promise<AxiosResponse> =>
    api.get(`/api/sem-tn-listes/${id}`, { params }),

  create: (data: EntityPayload): Promise<AxiosResponse> => api.post("/api/sem-tn-listes", { data }),

  update: (id: string, data: EntityPayload): Promise<AxiosResponse> =>
    api.put(`/api/sem-tn-listes/${id}`, { data }),

  delete: (id: string): Promise<AxiosResponse> => api.delete(`/api/sem-tn-listes/${id}`),
};
